
import React, { PropTypes } from 'react'
import Route from '../router/Route'
import NavLink from '../router/NavLink'
import WorkPage from '../work/WorkPage'
import AboutPage from '../pages/AboutPage'
import ApproachPage from '../pages/ApproachPage'
import OfficesPage from '../offices/OfficesPage'
import CareersPage from '../pages/CareersPage'
import ClientsPage from '../pages/ClientsPage'
import NewsPage from '../news/NewsPage'
import ScrollArrow from '../scrollarrow/ScrollArrow'

import {TimelineMax,TweenLite, Power2, Power0,TweenMax} from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

import MultiLangText from '../multilang/MultiLangText'

import {connect} from 'react-redux'


class AccordionPage extends React.Component {



  constructor(){
    super();
    this.state = {
        heightSetInterval: null,
        pageContentHeight: 'none',
        holdPageAtTop: false,
        animationTriggred: false,
        rotation_tl:null,
        isActive:false,
        showScrollArrow:true,
        revealText_tl:null,
        screenHeight: window.innerHeight,
        showPageContent:false
    }
    this.scrollToThis = this.scrollToThis.bind(this);
    this.onScroll = this.onScroll.bind(this)
    //this.rotatateAccordionSetup = this.rotatateAccordionSetup.bind(this);
    this.setIsActive = this.setIsActive.bind(this);

    this.setupTextReveal = this.setupTextReveal.bind(this)

    this.clickActiveToggle = this.clickActiveToggle.bind(this)

    this.onResize = this.onResize.bind(this)
  }

  setIsActive(active_boo){
    //console.log("Set Active",active_boo);
    this.setState({isActive:active_boo})
  }


  componentWillUpdate(newProps,newState){

      //console.log("Accordion",newProps);
      /*
      if(newProps.disableRotationAnimations===true){

          console.log("Clear Header Style");
          let innerHeader = this.refs.innerHeader;
              this.state.rotation_tl.kill();
              this.state.rotation_tl.clear();
              innerHeader.setAttribute('style','');
      }*/

  }


  scrollToThis(){

      //  console.log("Scroll to this",this.props.menu_link);
        //console.log('Scroll to ',this.props.pageNumber,this.refs.container.getBoundingClientRect(),);
        //console.log("Figure out a whay of animating the page position to hold it here");

        //console.log("This",this);

        this.props.beginTransition()

        let y = this.refs.container.getBoundingClientRect();
        /*
        setTimeout(()=>{
          let currentContainer = document.querySelector('.accordion-link.active')
          TweenLite.to(window,.5,{scrollTo:this.props.pageNumber*400})
        }
        ,0);*/

        //window.requestAnimationFrame(this.holdPageAtTopOfBrowser);
        //this.holdPageAtTopOfBrowser();

        // header bounds
        let header = this.refs.container.querySelector('.header')
        let headerBounds =  header.getBoundingClientRect();
        let wrapperBounds = document.querySelector('#pageAccordion').getBoundingClientRect();

        let slugClass = this.props.menu_link.split('/').join('')
        //console.log("header",headerBounds);



        this.setState({holdPageAtTop:true,showScrollArrow:false})

        // disable all rotation animations

        this.props.setDisableAnimations(true);


        /// force-hide-header
        document.querySelector('body').classList.add('force-hide-header')
        document.querySelector('header').classList.remove('show')
        document.querySelector('header').classList.add('hide')
        //this.refs.container.classList.add('hold-at-top')
        //header.classList.add('hold-at-top')


        let grow_tl = new TimelineMax()
            //grow_tl.fromTo(header,.52,{top:headerBounds.y,minHeight:headerBounds.height},{top:0,minHeight:window.innerHeight})
            grow_tl.add(()=>{
              document.querySelector('body').classList.remove('no-scroll');
              document.querySelector('#transitonHolder').classList.add('show');
              this.setState({showScrollArrow:false})
            })

            grow_tl.add(()=>{
              document.querySelector('body').classList.add('no-scroll')
            })
            grow_tl.add(()=>{

              document.querySelector('#transitonHolder .'+slugClass).classList.add('active');
            })
            //grow_tl.fromTo(header,.5,{top:headerBounds.y,minHeight:headerBounds.height+'px',force3D:true},{top:0,minHeight:window.innerHeight})

            //test

            if(this.isMobile()){
              //grow_tl.fromTo('#transitonHolder',.5,{top:headerBounds.y,minHeight:headerBounds.height+'px',force3D:true,alpha:1},{force3D:true,top:0,minHeight:window.innerHeight},'-=0')

            }else{
              grow_tl.fromTo('#transitonHolder',.5,{top:headerBounds.y,minHeight:headerBounds.height+'px',force3D:true,alpha:1},{force3D:true,top:0,minHeight:window.innerHeight},'-=0')
            }
            //grow_tl.fromTo('#transitonHolder',1,{top:headerBounds.y,minHeight:headerBounds.height+'px',force3D:true,alpha:1},{force3D:true,top:0,minHeight:window.innerHeight},'-=0')


            //grow_tl.fromTo(header,.5,{minHeight:headerBounds.height,force3D:true},{minHeight:window.innerHeight,force3D:true})

            //grow_tl.to(window,5,{scrollTo:((headerBounds.y-wrapperBounds.y)+82)},'-=5')
            //grow_tl.fromTo(header,.5,{top:headerBounds.y-wrapperBounds.y,minHeight:headerBounds.height,force3D:true},{top:0,minHeight:window.innerHeight})

            //let topPos = this.props.pageNumber*(window.innerWidth*0.333)+87;
            //grow_tl.fromTo(this.refs.container,header,.5,{top:headerBounds.y-wrapperBounds.y,force3D:true},{top:topPos},'-=.5')


            grow_tl.add(()=>{
              document.querySelector('body').classList.add('no-scroll')

            },'-=.5')


            grow_tl.add(() => {



                let spacerAtTpo = 87; // header height - borderWidth

                let winScrollY = this.props.pageNumber*(window.innerWidth*0.333)+87;


                // mobile scroll position


                if(window.innerWidth < 769){
                  winScrollY = this.props.pageNumber*(260)+91;
                }

                if(window.innerWidth < 481){
                  winScrollY = this.props.pageNumber*(200)+91;
                }



                grow_tl.set(window,{scrollTo:winScrollY})

                this.setState({showPageContent:true})

                setTimeout(()=>{

                  //this.setState({showScrollArrow:true})


                  //console.log("Clear Style",this.props.menu_link);

                  // Enable all rotation animation again
                  this.props.setDisableAnimations(false);
                },500)

                setTimeout(()=>{
                    this.setState({holdPageAtTop:false});
                    //this.refs.container.classList.remove('hold-at-top')
                    //header.classList.remove('hold-at-top')
                    TweenMax.set(window,{scrollTo:winScrollY})
                    this.setState({showScrollArrow:true})


                },610)
                  setTimeout(()=>{
                    /// stop force-hide-header
                    document.querySelector('body').classList.remove('force-hide-header'),
                    document.querySelector('body').classList.remove('no-scroll')
                    document.querySelector('#transitonHolder .'+slugClass).classList.remove('active');
                    document.querySelector('#transitonHolder .'+slugClass).setAttribute('style','');
                    document.querySelector('#transitonHolder').classList.remove('show');





                  //this.refs.container.classList.remove('hold-at-top')


                  },620)

            },'+=0')
            /*
            grow_tl.add(() => {


            },'+=4')*/







  }

  clickActiveToggle(){

      if(!this.state.isActive){
        //this.scrollToThis();
        this.setState({isActive:true})
      }else{
        //console.log('It is active');
        window.history.pushState(null, null, '/close-section');
      }


  }

  componentDidUpdate(prevProps,prevState){

    //console.log(this.props.menu_link,'isActive',prevState.isActive,this.state.isActive);

    // Check if we should scroll to this section
    if(!prevState.isActive && this.state.isActive){

      // remove trailing slashes.

      let menu_link = this.props.menu_link.replace(/\/+$/, "");
      let windowPath = window.location.pathname.replace(/\/+$/, "");

      if(menu_link.toLowerCase()===windowPath.toLowerCase()){
        //console.log("WE HAVE A WINNER",this.props.menu_link)
        this.scrollToThis()
      }else if(window.location.pathname.toLowerCase().indexOf(this.props.menu_link)!==-1){
        //console.log("We've got a deeplink");
        this.setState({showPageContent:true})
      }



    }

  }


 setupTextReveal(){

   const revealText_tl = new TimelineMax({repeat:0});



        revealText_tl.from(this.refs.title,1.5,{alpha:0,ease:Power0.easeNone})
        revealText_tl.from(this.refs.line1,.5,{scaleX:0},'-=.5')
        revealText_tl.from(this.refs.line2,.5,{scaleX:0},'-=.5');
        revealText_tl.pause();
        this.setState({revealText_tl})




 }

 onResize(){
    // reset the height if its more than 100px
    if(Math.abs(this.state.screenHeight - window.innerHeight)>100){
      //console.log("Reset Size");
      this.setState({screenHeight:window.innerHeight})
    }
 }



 onScroll(){

   let windowScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;


   let thisAtbottomOfBrowser = (windowScrollY-this.refs.container.offsetTop) + window.innerHeight;

      //console.log(this.props.menu_text_labels.en,'thisAtbottomOfBrowser',thisAtbottomOfBrowser);

      if(thisAtbottomOfBrowser>200 && this.state.revealText_tl.progress()===0){
        this.state.revealText_tl.play();
      }



 }
 componentDidMount(){
   //console.log("AccordionPage");
   //this.rotatateAccordionSetup()Link();

     window.addEventListener('scroll',this.onScroll);
     //if(window.innerWidth < 768){
       window.addEventListener('resize',this.onResize);
     //}

     this.setupTextReveal();

     setTimeout(this.onScroll,100)

     //console.log('this.props.menu_link',this.props.menu_link,window.location);

     // check if the slug is present on load, for deeplinking
     if(window.location.pathname.toLowerCase().indexOf(this.props.menu_link)!==-1){
       //console.log("We've got a deeplink");
       this.setState({showPageContent:true})
     }


 }
 componentWillUnmount(){
   window.removeEventListener('resize',this.onResize);
 }

 isMobile() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return true
      }

      if (/android/i.test(userAgent)) {
            return true
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return true
      }

      return false
  }




  render () {

      //console.log(this);


      let headerBgStyle = {
        backgroundImage: (this.props.menu_background)? `url('${this.props.menu_background.url}')` : ''
        //background:'#ccc'
      }

      let backgroundImageUrl = (this.props.menu_background)? this.props.menu_background.url : ''

      let headerActiveBgStyle = {
        backgroundImage: (this.props.menu_background)? `url('${this.props.menu_background_active.url}')` : ''

      }

      let backgroundActiveImageUrl = (this.props.menu_background)? this.props.menu_background_active.url : ''


      if(window.innerWidth < 1050){
          backgroundActiveImageUrl = this.props.menu_background_active.sizes.large
          backgroundImageUrl = this.props.menu_background.sizes.large
      }


      let portraitBackground = false;

      if(window.innerWidth < 767){
          backgroundActiveImageUrl = this.props.menu_background_active.sizes.medium_large
          backgroundImageUrl = this.props.menu_background.sizes.medium_large

          // Check to see if there is a portrait version
          if(window.innerWidth < window.innerHeight){
              //console.log("Use portrait image",this.props.menu_background_active_mobile);
              if(this.props.menu_background_active_mobile){
                  backgroundActiveImageUrl =  this.props.menu_background_active_mobile.url
                  portraitBackground = true;
              }
          }
      }



      //let fixHeader = (this.state.holdPageAtTop)? ' hold-at-top' : '';


      let arrowStyle = {}

      if(this.state.isActive && this.isMobile()){


        arrowStyle = {
            top: (this.props.screenSize.realScreenHeight - 150) +"px"
        }

        // landscape
        if(window.innerHeight < window.innerWidth){
          arrowStyle = {
              top: (this.props.screenSize.realScreenHeight - 110) +"px"
          }
        }
      }


      //console.log(this.props);

      let slugClass = this.props.menu_link.split('/').join('')

      return(<div className={"accordion-page scroll-anchor "+(slugClass)+" "+((this.state.isActive)?' active' : '')} ref="container"  pageslug={this.props.menu_link}  >
                <NavLink className="accordion-link"  isActive={this.setIsActive} to={this.props.menu_link} onClick={this.clickActiveToggle}  style={{}}>
                  <div className={"header "} ref="accordionLinkHeader">
                    <div className="inner-header" ref="innerHeader">
                        <div className="background" style={{}} >
                            <img src={backgroundImageUrl} alt="" />
                        </div>
                        <div className="background active" style={portraitBackground ? {backgroundImage:'url('+backgroundActiveImageUrl+')'} : {}} >
                            {(!portraitBackground)?
                                <img src={backgroundActiveImageUrl} alt="" />
                              : null
                            }
                        </div>

                          <div className="text-container">
                            <div className="text-inner">

                                <div className="text" >
                                <div className="line" ref="line1" />
                                <h3 ref="title"><MultiLangText text={this.props.menu_text_labels} /></h3>
                                <div className="line" ref="line2" />
                                </div>

                            </div>
                          </div>
                        </div>
                    </div>
                  </NavLink>

                  {(this.state.showScrollArrow)?
                    <ScrollArrow style={arrowStyle} />
                    : null
                  }

                  <div className="page-content" >
                      <div ref="pageContentInner">

                        {(this.state.showPageContent)?
                          <div>
                            {
                              (this.props.menu_link==='/about/')?
                                <Route path="/about/" onRemoved={this.props.endTransition} >
                                    <AboutPage />
                                </Route>

                              :(this.props.menu_link==='/offices/')?
                                    <Route path="/offices/" onRemoved={this.props.endTransition} >
                                        <OfficesPage />
                                    </Route>
                              :(this.props.menu_link==='/approach/')?
                                    <Route path="/approach/" onRemoved={this.props.endTransition} >
                                      <ApproachPage />
                                    </Route>
                              :(this.props.menu_link==='/work/')?
                                    <Route path="/work/" onRemoved={this.props.endTransition} >
                                        <WorkPage />
                                    </Route>
                              :(this.props.menu_link==='/clients/')?
                                    <Route path="/clients/" onRemoved={this.props.endTransition} >
                                        <ClientsPage />
                                    </Route>
                              :(this.props.menu_link==='/careers/')?
                                    <Route path="/careers/" onRemoved={this.props.endTransition} >
                                        <CareersPage />
                                    </Route>
                              :(this.props.menu_link==='/news/')?
                                    <Route path="/news/" onRemoved={this.props.endTransition} >
                                        <NewsPage />
                                    </Route>

                              : null

                          }
                        </div>
                        :null
                      }
                    </div>
                  </div>
            </div>
          )
  }
}


const mapStateToProps = (state)=>{
  //console.log('state',state);


  const screenSize = state.ScreenSize.screensize

    //console.log('screenSize',screenSize);

  return {
    screenSize
  }

}

export default connect(mapStateToProps)(AccordionPage);



// WEBPACK FOOTER //
// ./src/modules/pageAccordion/AccordionPage.js